import { useQuery } from "@tanstack/react-query";

import { useAuthData } from "shared/providers/auth/context";
import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import type { SubscriptionResponse } from "./types";

export const useSubscriptionQuery = (options?: {
  refetchInterval?: number | false;
}) => {
  const fetch = useAuthFetch();
  const { user } = useAuthData();
  return useQuery({
    queryKey: ["api", "tribute", "subscription", user.id],
    staleTime: 1000 * 30,
    refetchInterval: options?.refetchInterval ?? false,
    queryFn: async () => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/tribute/subscription`
      );
      const data: SubscriptionResponse = await response.json();
      return data;
    },
  });
};
